import { render, staticRenderFns } from "./SuggestATestPage.vue?vue&type=template&id=61b6d9f6&scoped=true&"
import script from "./SuggestATestPage.vue?vue&type=script&lang=js&"
export * from "./SuggestATestPage.vue?vue&type=script&lang=js&"
import style0 from "./SuggestATestPage.vue?vue&type=style&index=0&id=61b6d9f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b6d9f6",
  null
  
)

export default component.exports